import React from 'react'
import { FilmFilterKey, ShowtimeFilterKey, FilterType, GetNumberOfFiltersAppliedProps } from '@vista-digital/occ-domain'
import { getNumberOfFiltersApplied } from '@vista-digital/occ-ui/src/lib/utils/filters'
import { observer } from 'mobx-react'
import './composite-filter-counter.scss'
import { OmniFilterModes } from '../..'

export interface compositeFilterCounterProps {
    counterText?: string
    filterId: string
    filterMode: OmniFilterModes
}

export const CompositeFilterCounter = observer((props: compositeFilterCounterProps) => {
    const { filterId, counterText } = props

    const filmFilterProps: GetNumberOfFiltersAppliedProps = {
        id: props.filterId,
        type: FilterType.Film,
        keys: [FilmFilterKey.Genre, FilmFilterKey.Event, FilmFilterKey.Attribute, FilmFilterKey.Category],
    }

    const showtimeFilterProps: GetNumberOfFiltersAppliedProps = {
        id: props.filterId,
        type: FilterType.Showtime,
        keys: [ShowtimeFilterKey.Genre, ShowtimeFilterKey.Event, ShowtimeFilterKey.Attribute],
    }

    const filterCount = props.filterMode === OmniFilterModes.Film ? getNumberOfFiltersApplied(filmFilterProps) : getNumberOfFiltersApplied(showtimeFilterProps)

    const counterDisplayText = counterText
        ? counterText.replace('${count}', filterCount.toString())
        : filterCount.toString()

    return (
        <div className="composite-filter-counter">
            {filterCount > 0 && <span className="composite-filter-counter-content">{counterDisplayText}</span>}
        </div>
    )
})
